import { injectBaseConstantMethods } from "./BaseConstants"

const TimeLineOrderStatus = {
   OPEN: "OPEN",
   IN_PROGRESS: "IN_PROGRESS",
   COMPLETED: "COMPLETED",
}

const displayTextKeys = {
   [TimeLineOrderStatus.OPEN]: "Open",
   [TimeLineOrderStatus.IN_PROGRESS]: "In Progress",
   [TimeLineOrderStatus.COMPLETED]: "Completed",
}

const labelClass = {
   [TimeLineOrderStatus.OPEN]: "bg-red-req",
   [TimeLineOrderStatus.IN_PROGRESS]: "bg-yellow-req",
   [TimeLineOrderStatus.COMPLETED]: "bg-green-req",
}

export default injectBaseConstantMethods(
   TimeLineOrderStatus,
   displayTextKeys,
   labelClass
)
